import React from 'react';

import { style } from 'glamor';

type Props = {
  compact: ?Boolean,
};

export default ({compact}: Props) => (
  <div {...style({
    position: 'absolute',
    bottom: '0',
    right: compact ? '0' : '5%',
    width: compact ? '30%' : '20%',
    height: compact ? '30%' : '20%',
    zIndex: '1',
  })}>
    <svg viewBox="0 0 38 38">
      <g id="verified" stroke="#FFFFFF" strokeWidth="3">
        <circle id="circle" fill="#439FD8" cx="19" cy="19" r="17" />
        <polyline id="tick" fill="none" points="27.1479897 13 16 25.2621566 10.6417667 19.9039233" />
      </g>
    </svg>
  </div>
);



// WEBPACK FOOTER //
// ../src/client/components/badges/VerifiedBadge.js